import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-slate-900',
  tint: 'bg-slate-50 text-slate-900',
  deep: 'bg-teal-900 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-164" data-mp="2qdeoa9849xa">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-4xl' : 'max-w-5xl'}`} data-id="element-165" data-mp="7oyfobwauxms">
        {hasHeader && <header className="mx-auto max-w-4xl text-center" data-id="element-166" data-mp="vdhl8jnyswb6">
            {eyebrow && <p className={`mb-4 text-xs font-bold uppercase tracking-widest ${tone === 'deep' ? 'text-teal-200' : 'text-blue-600'}`} data-id="element-167" data-mp="105izuc8luz4d">
                {eyebrow}
              </p>}
            {title && <h2 className="text-3xl font-extrabold leading-tight tracking-tight md:text-5xl" data-id="element-168" data-mp="38dfbftrr06jh">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${tone === 'deep' ? 'text-teal-100' : 'text-slate-600'}`} data-id="element-169" data-mp="3ib32o9q5avww">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-170" data-mp="3r9nfwvcxsddq">{children}</div>
      </div>
    </section>;
}